module.exports = __webpack_public_path__ + "img/9788996697077.5084394a.jpg";